var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z",
    fill: "#00104A",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.931 45c11.008 0 19.932-8.954 19.932-20S35.939 5 24.93 5 5 13.954 5 25s8.924 20 19.931 20Z",
    fill: "#00104A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.486 24.145a1 1 0 0 1 0 1.71l-12.768 7.75a1 1 0 0 1-1.52-.855v-15.5a1 1 0 0 1 1.52-.854l12.768 7.75Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.486 24.145a1 1 0 0 1 0 1.71l-12.768 7.75a1 1 0 0 1-1.52-.855v-15.5a1 1 0 0 1 1.52-.854l12.768 7.75Z",
    stroke: "#fff"
  })));
};
export default SvgPlayButton;